import { __zcFin, __zcFinZ, __zcIT, __zcITc, __zcIV, __zcMkv } from "__zod-compiler-runtime__";
import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {LinkSchema} from './link'

export const DownloadPlatformSchema = /* @__PURE__ */ (() => {
var __zs=z.enum(['Android', 'iOS', 'Linux', 'macOS', 'Windows']);
function __fc_0(input){return (input==="Android"||input==="iOS"||input==="Linux"||input==="macOS"||input==="Windows");}
var __rfm_z=__zs.safeParse;
function safeParse_DownloadPlatformSchema(input){
if(__fc_0(input)){return{success:true,data:input};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_DownloadPlatformSchema,__zs,__fc_0,__fc_0);
})()
export const DownloadArchitectureSchema = /* @__PURE__ */ (() => {
var __zs=z.enum(['arm', 'x86']);
function __fc_0(input){return (input==="arm"||input==="x86");}
var __rfm_z=__zs.safeParse;
function safeParse_DownloadArchitectureSchema(input){
if(__fc_0(input)){return{success:true,data:input};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_DownloadArchitectureSchema,__zs,__fc_0,__fc_0);
})()

export const DownloadOptionSchema = /* @__PURE__ */ (() => {
var __zs=buildEntrySchemaFor('downloadOption', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      link: LinkSchema.refine(link => link.fields.text.trim().length > 0, {
        message: 'Download link text must not be blank',
        path: ['fields', 'text'],
      }),
      platform: DownloadPlatformSchema,
      architecture: DownloadArchitectureSchema.optional(),
    }),
  ),
});
var __rf=[__zs._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["link"]._zod.innerType.shape["sys"].shape["contentType"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["link"]._zod.innerType.shape["fields"]._zod.innerType.shape["text"],__zs._zod.innerType.shape["fields"]._zod.innerType.shape["link"]];
var __rfp_0=__rf[0].safeParse.bind(__rf[0]);
var __rfp_3=__rf[3].safeParse.bind(__rf[3]);
function safeParse_DownloadOptionSchema(input){
var _e=[];
var _d=input;
if(typeof _d!=="object"||_d===null||Array.isArray(_d)){_e.push(__zcIT("object",_d,[]));}else{var __sv_1=_d["sys"];if(typeof __sv_1!=="object"||__sv_1===null||Array.isArray(__sv_1)){_e.push(__zcIT("object",__sv_1,["sys"]));}else{var __sv_3=__sv_1["id"];if(typeof __sv_3!=="string"){_e.push(__zcIT("string",__sv_3,["sys","id"]));}
var __sv_4=__sv_1["updatedAt"];if(__sv_4!==undefined){if(typeof __sv_4!=="string"){_e.push(__zcIT("string",__sv_4,["sys","updatedAt"]));}
}
var __sv_5=__sv_1["createdAt"];if(__sv_5!==undefined){if(typeof __sv_5!=="string"){_e.push(__zcIT("string",__sv_5,["sys","createdAt"]));}
}
var __sv_6=__sv_1["contentType"];var __op_8="contentType" in __sv_1;var __ob_7=_e.length;var __rf_r0=__rfp_0(__sv_6);if(!__rf_r0.success){var __rf_i0=__rf_r0.error.issues;for(var __rf_j0=0;__rf_j0<__rf_i0.length;__rf_j0++){_e.push({...__rf_i0[__rf_j0],path:["sys","contentType"].concat(__rf_i0[__rf_j0].path)});}}else{__sv_6=__rf_r0.data;}
if(!__op_8){__sv_6=undefined;if(_e.length===__ob_7){_e.push(__zcITc("nonoptional",undefined,["sys","contentType"]));}}var __o_2={"id":__sv_3};if(__sv_4!==undefined||("updatedAt" in __sv_1)){__o_2["updatedAt"]=__sv_4;}if(__sv_5!==undefined||("createdAt" in __sv_1)){__o_2["createdAt"]=__sv_5;}if(__sv_6!==undefined||("contentType" in __sv_1)){__o_2["contentType"]=__sv_6;}__sv_1=__o_2;}
var __sv_9=_d["fields"];if(typeof __sv_9!=="object"||__sv_9===null||Array.isArray(__sv_9)){_e.push(__zcIT("object",__sv_9,["fields"]));}else{var __sv_11=__sv_9["title"];if(typeof __sv_11!=="string"){_e.push(__zcIT("string",__sv_11,["fields","title"]));}
var __sv_12=__sv_9["link"];var __op_14="link" in __sv_9;var __ob_13=_e.length;var __rf_r3=__rfp_3(__sv_12);if(!__rf_r3.success){var __rf_i3=__rf_r3.error.issues;for(var __rf_j3=0;__rf_j3<__rf_i3.length;__rf_j3++){_e.push({...__rf_i3[__rf_j3],path:["fields","link"].concat(__rf_i3[__rf_j3].path)});}}else{__sv_12=__rf_r3.data;}
if(!__op_14){__sv_12=undefined;if(_e.length===__ob_13){_e.push(__zcITc("nonoptional",undefined,["fields","link"]));}}var __sv_15=__sv_9["platform"];if(__sv_15!=="Android"&&__sv_15!=="iOS"&&__sv_15!=="Linux"&&__sv_15!=="macOS"&&__sv_15!=="Windows"){_e.push(__zcIV(["Android","iOS","Linux","macOS","Windows"],__sv_15,["fields","platform"]));}
var __sv_16=__sv_9["architecture"];if(__sv_16!==undefined){if(__sv_16!=="arm"&&__sv_16!=="x86"){_e.push(__zcIV(["arm","x86"],__sv_16,["fields","architecture"]));}
}
var __o_10={"title":__sv_11};if(__sv_12!==undefined||("link" in __sv_9)){__o_10["link"]=__sv_12;}__o_10["platform"]=__sv_15;if(__sv_16!==undefined||("architecture" in __sv_9)){__o_10["architecture"]=__sv_16;}__sv_9=__o_10;}
var __o_0={"sys":__sv_1,"fields":__sv_9};_d=__o_0;}

if(_e.length===0){return{success:true,data:_d};}
return __zcFin(_e,_d);
}
return __zcMkv(safeParse_DownloadOptionSchema,__zs,null,null);
})()

export type DownloadOption = z.infer<typeof DownloadOptionSchema>
